export const userId = state => state.userId
